const IframeController = require('../../../utils/IframeController')(true);

module.exports = () => {
  const congratsHeight = 370;
  IframeController.resize(congratsHeight);
};
